import revive_payload_client_4sVQNw7RlN from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import Vue3Lottie_client_bMZiOS6AB0 from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/plugins/Vue3Lottie.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  Vue3Lottie_client_bMZiOS6AB0
]